<template>
  <v-container fluid pa-0 ma-0>
    <v-container fluid pa-0 ma-0 class="test_purple header-background">
      <v-row no-gutters align="start">
        <div class="header">
          <MenuHeaderPublic />
        </div>
      </v-row>
    </v-container>
    <main class="pt-16 fill-height mt-2">
      <v-container class="test_yellow container-policy">
        <v-col no-gutters>
          <h2 class="policy-title" v-text="$t('general.privacyPolicy')" />
          <p
            class="policy-content"
            v-text="
              $t('privacyPolicy.dataController.content', {
                FIRMANAVN: companyDetails.name,
              })
            "
          />
          <p class="policy-content">
            {{
              $t("privacyPolicy.dataController.addressLine1", {
                FIRMANAVN: companyDetails.name,
              })
            }}<br />{{
              $t("privacyPolicy.dataController.addressLine2", {
                ADRESSE: companyDetails.address,
              })
            }}<br />{{
              $t("privacyPolicy.dataController.addressLine3", {
                CVR: companyDetails.vat_number,
              })
            }}
          </p>
          <p
            class="policy-content"
            v-text="
              $t('privacyPolicy.dataController.content2', {
                MAILADRESSE: companyDetails.email,
              })
            "
          />
          <span class="policy-title-bold">{{ treatment }}</span
          ><br /><span class="policy-sub-title">{{ visitWeb }}</span>
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.dataController.visitWebText')"
          />
          <!--          <h6-->
          <!--            class="policy-sub-title"-->
          <!--            v-text="$t('privacyPolicy.dataController.communication.title')"-->
          <!--          />-->
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.dataController.communication.content')"
          />
          <p
            class="policy-content mt-10"
            v-text="
              $t('privacyPolicy.dataController.communication.contactForm')
            "
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.dataController.communication.content2')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.dataController.communication.content3')"
          />
          <p
            class="policy-content"
            v-text="
              $t('privacyPolicy.dataController.communication.content4', {
                FIRMANAVN: companyDetails.name,
              })
            "
          />
          <p
            class="policy-content mt-10"
            v-text="$t('privacyPolicy.intro.line1')"
          />
          <p class="policy-content" v-text="$t('privacyPolicy.intro.line2')" />
          <p class="policy-content" v-text="$t('privacyPolicy.intro.line3')" />
          <p class="policy-content" v-text="$t('privacyPolicy.intro.line4')" />
          <!-- cookies -->
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.cookie.content')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.cookie.content2')"
          />
          <!-- security -->
          <h6
            class="policy-sub-title"
            v-text="$t('privacyPolicy.security.title')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.security.content')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.security.content2')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.security.content3')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.security.content4')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.security.content5')"
          />
          <!-- purpose -->
          <p
            class="policy-content mt-10"
            v-text="$t('privacyPolicy.purpose.title')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.purpose.content')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.purpose.content2')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.purpose.content3')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.purpose.content4')"
          />
          <!-- periodOfStorage -->
          <p
            class="policy-content mt-10"
            v-text="$t('privacyPolicy.periodOfStorage.title')"
          />
          <p
            class="policy-content mt-5"
            v-text="$t('privacyPolicy.periodOfStorage.content')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.periodOfStorage.content2')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.periodOfStorage.content3')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.periodOfStorage.content4')"
          />
          <p
            class="policy-content"
            v-text="$t('privacyPolicy.periodOfStorage.content5')"
          />
          <!-- disclosureOfInformation -->
        </v-col>
      </v-container>
    </main>
    <!--    <v-container-->
    <!--      id="container-discovery"-->
    <!--      fluid-->
    <!--      class="test_green container-discovery bg-color"-->
    <!--      :class="{-->
    <!--        'content-mobile': $vuetify.breakpoint.xs,-->
    <!--        'bg-color-mobile': $vuetify.breakpoint.xs,-->
    <!--      }"-->
    <!--      style="padding-top: 70px"-->
    <!--    >-->
    <!--      <h2 v-text="$t('privacyPolicy.dataController.title')" />-->
    <!--    </v-container>-->
  </v-container>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data: () => ({
    companyDetails: null,
  }),
  created() {
    this.fetchCompanyData().then();
  },
  methods: {
    async fetchCompanyData() {
      try {
        const response = await axios.get("/app/companyDetails");
        this.companyDetails = response.data.data;
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    },
    goBack() {
      // Handle the back button click event here
      // For example, you can use Vue Router to navigate back
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.policy-title {
  font-size: 2rem !important;
}
.policy-title-bold {
  font-size: 0.9rem !important;
  font-weight: bold;
}
.policy-sub-title {
  font-size: 1.3rem !important;
  font-weight: bold;
}
.policy-content {
  font-size: 1.1rem !important;
}
.container-policy {
  max-width: 1400px !important;
  margin: 0 auto;
}

@media screen and (max-width: 960px) {
  .container-policy {
    max-width: none;
    padding: 0 15px !important;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1400px) {
  .container-policy {
    padding: 0 30px !important;
  }
}
</style>
